import { render, staticRenderFns } from "./ReportMaterialsDemountingEditor.vue?vue&type=template&id=17e5cf40&"
import script from "./ReportMaterialsDemountingEditor.vue?vue&type=script&lang=js&"
export * from "./ReportMaterialsDemountingEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon,QItem,QItemSection,QList,QItemLabel,QInput,QSelect,QSeparator,QCardActions,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QIcon,QItem,QItemSection,QList,QItemLabel,QInput,QSelect,QSeparator,QCardActions,QBtn}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
